// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://thejobship-3ru2.onrender.com/",
});

export default axiosInstance;

export const weburl = "https://thejobship-3ru2.onrender.com/";
export const shopurl = "https://gojobify.in/";
export const mainurl = "https://gojobify.in/";
export const fronturl = "https://gojobify.in/";
export const MAPAPI = "AIzaSyBHphidysElJ48mG4AAroD5e7pIJ57XCFg"; 
export const keyLogin = process.env.REACT_APP_LOGIN_KEY;
